import React from 'react';
import { NavLink } from 'react-router-dom';
import { navData } from '../../Data/Data.js';

export default function Footer() {
    // Filter out items with dropdowns for the footer
    const footerNavLinks = navData.filter(item =>
        ['About Us', 'Projects', 'Media Center', 'Contact Us'].includes(item.name)
    );
    return (
        <footer className="bg-zinc-800 text-slate-400 py-16 mt-20 selection:bg-red-500">
            <div className="container mx-auto px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
                    {/* Copyright text */}
                    <div className="text-center md:text-left">
                        <p className="text-lg">© Rakan CO - All Rights Reserved.</p>
                    </div>

                    {/* Navigation Links */}
                    <nav className="grid grid-cols-2 gap-x-6 gap-y-3 md:flex md:space-x-6">
                        {footerNavLinks.map((link, index) => (
                            <React.Fragment key={link.url}>
                                <NavLink
                                    to={link.url}
                                    className={({ isActive }) =>
                                        `uppercase transition-colors duration-300 px-2 py-1 ${isActive ? 'text-white font-bold' : 'hover:text-white'
                                        }`
                                    }
                                >
                                    {link.name}
                                </NavLink>
                                {index < footerNavLinks.length - 1 && (
                                    <span className="hidden md:inline text-slate-400">|</span>
                                )}
                            </React.Fragment>
                        ))}
                    </nav>
                </div>
            </div>
        </footer>
    );
}
